// Note, in the future this may become a part of shared config space
export const Tags = {
  IFRAME: 'IFRAME',
  APP: 'APP',
  NAV: 'NAV',
} as const;

export type Tags = typeof Tags;
export type Tag = Tags[keyof Tags];
export type TagValues = ReadonlyArray<Tag>;
